export default function MySQL_DATES() {
  return (
    <div>
      <h2>MySQL_DATES</h2>    </div>
  );
}